import api from 'api';

export const loadStatuses = api(
  'GET /api/lookalikes-audiences/filters/statuses'
);
export const loadCountries = api(
  'GET /api/lookalikes-audiences/filters/countries'
);
export const loadPartners = api(
  'GET /api/lookalikes-audiences/filters/partners'
);
export const loadDataTypes = api(
  'GET /api/lookalikes-audiences/filters/data-types'
);
export const loadAccounts = api(
  'GET /api/lookalikes-audiences/filters/accounts'
);
export const loadCreatedBy = api(
  'GET /api/lookalikes-audiences/filters/createdBy'
);
export const loadApplications = api(
  'GET /api/lookalikes-audiences/filters/applications'
);
